import { render, staticRenderFns } from "./attr-imagepanel.vue?vue&type=template&id=c6278d06"
import script from "./attr-imagepanel.vue?vue&type=script&lang=js"
export * from "./attr-imagepanel.vue?vue&type=script&lang=js"
import style0 from "./attr-imagepanel.vue?vue&type=style&index=0&id=c6278d06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports